module.exports = __webpack_public_path__ + "94cb0ae034413c9b6f2ac012ee2194bf.png";